<template>
    <div>Coming Soon</div>
</template>
<script>
export default {
    name: "dashboardshippop",
    data() {
        return {

        };
    }
}
</script>
